import axios, { AxiosRequestConfig } from 'axios'
/* eslint-disable no-restricted-globals */
const baseHost = window.location.protocol + '//' + window.location.hostname
const logoutUrl = baseHost + '/logout'
const isLandbruksdirektoratetDomain = window.location.hostname.includes('landbruksdirektoratet.no')

export const logOut = (callback?: Function) => {
    if (isLandbruksdirektoratetDomain) {
        location.href = logoutUrl
        callback && callback()
    }
}

const resourceBasePath = '/api'
const testBaseUrl = '//localhost'

class WrappedApi {
    public innerApi

    constructor() {
        let host
        if (process.env.NODE_ENV !== 'production') {
            host = testBaseUrl + ':22242'
        } else {
            if (isLandbruksdirektoratetDomain) {
                host = baseHost
            } else {
                host = baseHost + ':22242'
            }
        }
        const innerApi = axios.create({
            baseURL: host + resourceBasePath,
            timeout: 60000,
            withCredentials: process.env.NODE_ENV === 'production'
        })

        innerApi.defaults.headers.post['Content-Type'] = 'application/json'

        this.innerApi = innerApi
    }

    get(url: string, params?: AxiosRequestConfig | undefined) {
        return this.innerApi.get(url, params)
    }

    post(url: string, data: any, config: AxiosRequestConfig | undefined) {
        return this.innerApi.post(url, data, config)
    }

    delete(url: string, config: AxiosRequestConfig | undefined) {
        return this.innerApi.delete(url, config)
    }

    put(url: string, data: any, config: AxiosRequestConfig | undefined) {
        return this.innerApi.put(url, data, config)
    }
}

export const api = new WrappedApi()

export const resources = {
    merke: 'v1/reinmerke/merker',
    geografi: 'v1/reinmerke/geografi',
    person: {
        navn: 'v2/person/navn',
        merker: 'v2/person/merker',
    },
    snitt: 'v1/reinmerke/snitt',
    bruker: 'v2/bruker/informasjon',
    session: 'v1/bruker',
    tekster: 'v1/reinmerke/tekster',
    konfigurasjon: 'v1/reinmerke/konfigurasjon',
}
